/* eslint-disable enforce-ids-in-jsx/missing-ids */
import React from 'react'

import { formateDesignSystemDate } from 'utils/dateUtils'

import Tooltip from 'components/lib/DesignSystem/Tooltip'

import { CreatedAtText, DateDetailsContainer, EffectiveUntilText } from '../styles'
import { formatSuggestedSimulationTimestamp } from '../utils'

const EXPIRED_TOOLTIP_TEXT =
  "This simulation's OSINT relevance window has passed. It can still be launched for training purposes."

const DateDetails = ({ campaignId, createdAt, expiresAt, isExpired }) => {
  const createdAtTimestamp = formatSuggestedSimulationTimestamp(createdAt)

  return (
    <DateDetailsContainer
      id={`Psima_Dashboard_DateDetails_div-${campaignId}`}
      data-testid={`Psima_Dashboard_DateDetails_div-${campaignId}`}
    >
      <CreatedAtText $unavailable={createdAtTimestamp.unavailable} title={createdAtTimestamp.title}>
        {createdAtTimestamp.label}
      </CreatedAtText>
      {expiresAt && (
        <Tooltip
          text={isExpired ? EXPIRED_TOOLTIP_TEXT : undefined}
          placement="top"
          ignoreTooltip={!isExpired}
        >
          <EffectiveUntilText $expired={isExpired}>
            {`Effective Until: ${formateDesignSystemDate(new Date(expiresAt), {
              withYear: true,
              monthFirst: true,
            })}`}
          </EffectiveUntilText>
        </Tooltip>
      )}
    </DateDetailsContainer>
  )
}

export default DateDetails
